import { DCCallback, useCallbackHandler } from "@/stores/RootStoreContext";
import { isEscape } from "@/utils/keyboardEvents";
import { FC } from "react";

export type FormProps = {
  className?: string;
  submitOnEnter?: boolean;
  onSubmit?: DCCallback;
  onCancel?: DCCallback;
  children?: React.ReactNode;
  loading?: boolean;
};

const Form: FC<FormProps> = ({
  onSubmit,
  onCancel,
  submitOnEnter,
  className,
  loading,
  children,
}) => {
  const handleSubmit = useCallbackHandler(onSubmit);
  const handleCancel = useCallbackHandler(onCancel);
  return (
    <form
      noValidate
      className={className}
      onSubmit={(e) => {
        e.preventDefault();
        if (!loading) {
          handleSubmit?.();
        }
      }}
      onKeyDown={
        handleCancel
          ? (event) => {
              if (!loading && isEscape(event)) {
                handleCancel();
              }
            }
          : undefined
      }
    >
      {children}
      {submitOnEnter && <input style={{ display: "none" }} type="submit" />}
    </form>
  );
};

export default Form;
